module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/biolerplate-169.vue");


//////////////////
// WEBPACK FOOTER
// ./en/install/biolerplate.md
// module id = 605
// module chunks = 465